import { Component } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import withComponentName from '../../../../decorators/withComponentName';
import PresentationsSvc from '../../../../services/dbServices/PresentationsSvc';
import { TOPIC_CLASS_BREADCRUMBS } from '../../../../data/directory/constants';
import { GOLD } from '../../../../data/permissions';

import Preloader from '../../../Preloader';
import Breadcrumbs from '../../../Breadcrumbs';
import NewTag from '../../../Shared/NewTag';
import ButtonComponent from '../../../Buttons/ButtonComponent';
import Tooltip from '../../../Tooltip';
import PresentationTable from './PresentationTable';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class SinglePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      presentation: {},
      breadcrumbs: [],
    };

    autoBind(this);
  }

  componentDidMount() {
    const { permissionsInitialized } = this.props;
    if (permissionsInitialized) {
      this.getPresentationData();
    }
  }

  componentDidUpdate(prevProps) {
    const { permissionsInitialized } = this.props;
    if (permissionsInitialized && prevProps.permissionsInitialized !== permissionsInitialized) {
      this.getPresentationData();
    }
  }

  async getPresentationData() {
    const { match: { params }, isPremium } = this.props;
    const id = params.id.split('-')[0];
    const param = {
      id,
      is_premium: isPremium,
    };
    const dataArr = await this.callPresentationAPI(param);
    if (!dataArr.length) {
      window.location.href = '/404';
      return;
    }
    const currentData = dataArr[0];

    const breadcrumbs = TOPIC_CLASS_BREADCRUMBS.concat([
      {
        name: currentData.companyName,
        path: '',
        className: Styles.disable_breadcrumbs,
      },
      {
        name: currentData.title,
      },
    ]);

    this.setState({
      breadcrumbs,
      presentation: currentData,
      loadingPage: false,
    });
  }

  callPresentationAPI(param) {
    return PresentationsSvc.getPresentationsData(param)
      .then(({ data }) => data)
      .catch(() => []);
  }

  render() {
    const { loadingPage, breadcrumbs, presentation } = this.state;
    const { isPremium, width, searchBarActive } = this.props;

    if (loadingPage || !presentation) {
      return (
        <div className={Styles.single_page}>
          <Preloader loading />
        </div>
      );
    }

    return (
      <div className={cx(Styles.single_page, searchBarActive && Styles.blurred)}>
        <div className={Styles.single_page_container}>
          <Breadcrumbs items={breadcrumbs} />

          <div className={Styles.single_page_head}>
            {presentation.title}
            <NewTag />
          </div>

          <PresentationTable
            presentation={presentation}
          />

          <div className={Styles.single_original_button}>
            {isPremium ? (
              <ButtonComponent
                path={presentation.link}
                value="See Original Report"
                isBlank
                dynamic
                align_center
              />
            ) : (
              <Tooltip
                className={Styles.plan_suggestion}
                icon={(
                  <div className={Styles.see_original_report}>
                    See Original Report
                    <span>{width <= 767 ? 'GOLD' : 'G'}</span>
                  </div>
                )}
              >
                <Link to="/pricing" className={Styles.plan_url}>Upgrade to Gold plan</Link>
                &nbsp;to use this feature
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ subscriptions, common, searchReducers }) => {
  const { permissions, permissionsInitialized } = subscriptions;
  const { access_levels: accessLevels } = permissions;

  return {
    isPremium: accessLevels.includes(GOLD),
    permissionsInitialized,
    width: common.width,
    searchBarActive: searchReducers.searchBarActive,
  };
};

export default withComponentName(connect(mapStateToProps, {})(SinglePage));
